import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { KraIncentiveListComponent } from './kra-incentive-list/kra-incentive-list.component';
import { KraIncentiveListAddComponent } from './kra-incentive-list-add/kra-incentive-list-add.component';

const routes: Routes = [
  { path: 'kralist', component: KraIncentiveListComponent },
  { path: 'kraadd', component: KraIncentiveListAddComponent },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KraIncentivesRoutingModule { }
